/* @flow */
import ActivityCreateDialogContainer from 'payments/containers/ActivityCreateDialogContainer.jsx';
import Button from 'components/Button.jsx';
import Container from 'components/Container.jsx';
import Group from 'entities/Group';
import GroupStore from 'groups/stores/GroupStore';
import JoinGroupModal from 'groups/components/JoinGroupModal.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';
import CurrentUser from 'auth/CurrentUser';

import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';

import './styles/ActivitiesTabNux.scss';

type Props = {
  canManage: boolean,
  hideImage: boolean,
  group?: ?Group,
}

class ActivitiesTabNux extends React.Component {
  props: Props;

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static defaultProps = {
    hideImage: false,
  };

  handleGroupJoined = (group: Group): void => {
    this.context.router.push(getRedirectLocationAfterGroupJoin(group));
  };

  renderNonManager() {
    let button = null;
    let text = 'No activities yet';
    let subtext = 'Activities shared to you will appear here.';
    const joinedAGroup = GroupStore.getSubscribedGroups().length > 0;

    if (this.props.group && this.props.group.isRoot()) {
      text = 'Ready for action?';
      subtext = 'Keep track of field trips, fundraisers, and other activities.';

      if (!joinedAGroup) {
        button = (
          <ModalTrigger modal={<JoinGroupModal onJoin={this.handleGroupJoined} />}>
            <Button level="secondary">
              Join a class
            </Button>
          </ModalTrigger>
        );
      }
    }

    return (
      <div className="ActivitiesTabNux">
        <Container size="xsmall">
          <TitleHeader
            size="medium"
            imageClassName="ActivitiesTabNux-img"
            image={this.props.hideImage ? undefined : require('assets/images/payments/activity_creation_field_trip.svg')}
            title={text}
            subtext={subtext}
          />
          {button}
        </Container>
      </div>
    );
  }

  renderManager() {
    const canCollectMoney = CurrentUser.isSignedIn() && CurrentUser.getUser().canCollectMoney();

    let text = 'Take the hassle out of organizing field trips and fundraisers';
    let subtext = canCollectMoney ?
      'Track participation, coordinate volunteers, and collect funds—all in one place.You can also send real-time updates and photos!' :
      'Track participation and coordinate volunteers. You can also send real-time updates and photos!';

    if (this.props.group && this.props.group.isRoot()) {
      text = 'An easier way to coordinate activities';
      subtext = canCollectMoney ?
        'Send important details, track who‘s participating, and collect funds online.' :
        'Send important details and track who‘s participating.';
    }

    return (
      <div className="ActivitiesTabNux">
        <Container size="medium">
          <ModalTrigger modal={<ActivityCreateDialogContainer />}>
            <div>
              <TitleHeader
                size="medium"
                imageClassName="ActivitiesTabNux-img"
                image={this.props.hideImage ? undefined : require('assets/images/payments/activity_creation_field_trip.svg')}
                title={text}
                subtext={subtext}
              />
            </div>
          </ModalTrigger>

          <ModalTrigger modal={<ActivityCreateDialogContainer />}>
            <Button>Create an activity</Button>
          </ModalTrigger>
        </Container>
      </div>
    );
  }

  render() {
    const { canManage } = this.props;
    const hasGroupToSentTo = GroupStore.getOwnedGroups().length > 0;

    return (canManage && hasGroupToSentTo) ?
      this.renderManager() :
      this.renderNonManager();
  }
}

export default ActivitiesTabNux;



// WEBPACK FOOTER //
// ./src/payments/components/ActivitiesTabNux.jsx